// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"542":"03ae1899","601":"942d9931","767":"2589e252","779":"c6459aa3","864":"4acd32b7","940":"e715601c"}[chunkId] + ".chunk.css";
};